import React from "react";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import TableWithAddForm from "../../../../components/TableWithAddForm";
import { Row, Col, Panel, Button, Glyphicon } from "react-bootstrap";
import { connect } from "react-redux";
import {
  partner,
  isPartnerLoading,
  usersAdmin,
  usersTech,
} from "../../selectors/partners";
import PartnerForm from "../../components/forms/Partner";
import LogoForm from "../../components/forms/Logo";
import { push } from "react-router-redux";
import {
  partnerPageLoad,
  partnerUpdateRequest,
  partnerQueueAddRequest,
  partnerQueueDeleteRequest,
  partnerLogoUploadRequest,
  partnerLogoDeleteRequest,
} from "../../actions/partners";
import Table from "../../../../components/Table";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";
import DisableBadge from "sc/ui/sites/oncall/components/DisableBadge";

export default props =>
  isNaN(props.match.params.id) ? (
    <PageNotFound />
  ) : (
    <EditPartnerPage partnerId={parseInt(props.match.params.id, 10)} />
  );

const EditPartnerPage = connect(
  (state, ownProps) => ({
    partner: partner(state),
    partnerUsersAdmin: usersAdmin(state),
    partnerUsersTech: usersTech(state),
    loading: isPartnerLoading(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: partnerId => dispatch(partnerPageLoad(ownProps.partnerId)),
    onSave: formData =>
      dispatch(partnerUpdateRequest(ownProps.partnerId, formData)),
    onAddQueue: queue =>
      dispatch(partnerQueueAddRequest(ownProps.partnerId, queue)),
    onDeleteQueue: queue =>
      dispatch(partnerQueueDeleteRequest(ownProps.partnerId, queue)),
    onPartnerList: () => dispatch(push("/")),
    onSaveLogo: formData =>
      dispatch(partnerLogoUploadRequest(ownProps.partnerId, formData)),
    onDeleteLogo: () => dispatch(partnerLogoDeleteRequest(ownProps.partnerId)),
    onEditUser: username =>
      dispatch(push(`/partner/users/edit/${ownProps.partnerId}/${username}`)),
    onAddUser: () => dispatch(push(`/partner/users/new/${ownProps.partnerId}`)),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading || props.partner.logoLoadInProgress) {
      return <PageTitle title="Loading..." />;
    }

    const actions = [
      {
        id: "edit-user",
        text: " Edit",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-pencil",
        onClick: props.onEditUser,
      },
    ];

    const columns = [
      {
        header: "",
        data: user => user.username,
        badges: user => {
          const allBadges = [];
          if (!user.enabled)
            allBadges.push([<DisableBadge key="disabled-badge" />]);
          return allBadges;
        },
      },
    ];

    return (
      <div id="edit-partner-page">
        <PageTitle title="Edit Partner" />
        <div>
          <a
            id="back"
            style={{ cursor: "pointer" }}
            onClick={props.onPartnerList}
          >
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to partners list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Partner data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <PartnerForm
                  partner={props.partner}
                  onSave={props.onSave}
                  disabled={props.partner.generalDataSaveInProgress}
                  backendError={props.partner.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>

        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Partner Logo</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                {props.partner.logo && (
                  <div className="text-center" id="logo-box">
                    <img
                      alt="logo"
                      style={{ maxWidth: "200px" }}
                      src={props.partner.logo}
                    />
                    <br />
                    <Button
                      id="delete-logo"
                      disabled={props.partner.logoDeleteInProgress}
                      className=" btn btn-danger btn-xs"
                      onClick={props.onDeleteLogo}
                    >
                      <span className="glyphicon glyphicon-glyphicon glyphicon-trash" />
                      Delete
                    </Button>
                    <br />
                    <br />
                  </div>
                )}

                <LogoForm
                  partner={props.partner}
                  onSave={props.onSaveLogo}
                  disabled={props.partner.logoUploadInProgress}
                  backendError={props.partner.logoUploadError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>

        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Partner Queues</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <TableWithAddForm
                  title="Queues"
                  queue
                  disabled={props.partner.queueAddInProgress}
                  backendError={props.partner.queueAddError}
                  data={props.partner.queues}
                  onAdd={props.onAddQueue}
                  onDelete={props.onDeleteQueue}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>

        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Users</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <Button
                  id="add-user"
                  onClick={props.onAddUser}
                  className="btn-success"
                >
                  <Glyphicon glyph="glyphicon glyphicon-plus" />
                  &nbsp;Add User
                </Button>
                <Panel bsStyle="warning" id="users-admin-panel">
                  <Panel.Heading>
                    <Panel.Title componentClass="h3">
                      Administrators
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Table
                      data={props.partnerUsersAdmin}
                      columns={columns}
                      actions={actions}
                      identityProperty="username"
                      noDataMessage="No users of type admin defined"
                      loading={props.loading}
                      loadingMessage="Loading..."
                    />
                  </Panel.Body>
                </Panel>
                <Panel bsStyle="warning" id="users-tech-panel">
                  <Panel.Heading>
                    <Panel.Title componentClass="h3">Technicians</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Table
                      data={props.partnerUsersTech}
                      columns={columns}
                      actions={actions}
                      identityProperty="username"
                      noDataMessage="No users of type tech defined"
                      loading={props.loading}
                      loadingMessage="Loading..."
                    />
                  </Panel.Body>
                </Panel>
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/EditPartnerPage.js